import { tryCompleteHex } from '../hexagonColorPicker.utils';

export function normalizePickerHexForCompare(hex: string): string {
  return (tryCompleteHex(hex) ?? hex.trim()).toLowerCase();
}

export function fillsMatch(fill: string, selected: string): boolean {
  return normalizePickerHexForCompare(fill) === normalizePickerHexForCompare(selected);
}
